import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash} from '@fortawesome/free-solid-svg-icons';

interface CategoryEditorProps {
  categories: string[];
  onChange?: (categories: string[]) => void;
}

function CategoryEditor({categories, onChange}: CategoryEditorProps) {
  const [input, setInput] = useState('');

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setInput(e.currentTarget.value);
  };

  const handleSubmit = () => {
    if (input === '' || onChange === undefined) {
      return;
    }

    const newCategories = categories.concat(input);
    onChange(newCategories);
    setInput('');
  };

  const handleDelete = (category: string) => {
    if (onChange === undefined) {
      return;
    }

    const newCategories = categories.filter(c => c !== category);
    onChange(newCategories);
  };

  let inputFields = undefined;
  let items = categories.map(c => <li key={c}>{c}</li>);
  if (onChange !== undefined) {
    inputFields = (
      <>
        <input type="text" value={input} onChange={handleChange} />
        <input type="submit" onClick={handleSubmit} value="Add" />
      </>
    );

    items = categories.map(c => {
      return (
        <li key={c}>
          {c}
          <span onClick={() => handleDelete(c)}><FontAwesomeIcon className="pull-right" icon={faTrash} /></span>
        </li>
      );
    });
  }

  return (
    <div>
      <ul>
        {items}
      </ul>
      {inputFields}
    </div>
  );
}

export default CategoryEditor;
